var courses=[
    {key:"1", 
    title:"React Libray Guide", 
    instructor:"Asaduzzaman Sajeeb", 
    price:30,
    img:'https://i.ibb.co/gT36Dyv/a.jpg'},
    {key:"2", title:"Angular Framework", instructor:"Shaabab Hossain", price:50,img:'https://i.ibb.co/Rhhtn5X/b.jpg'},
    {key:"3", title:"Django Framework ", instructor:"Yousha Mahmood", price:30,img:'https://i.ibb.co/xsByy9m/q.jpg'},
    {key:"4", title:"Flutter Development", instructor:"Rakibul Islam", price:20,img:'https://i.ibb.co/XbHJ511/r.jpg'},
    {key:"5", title:" React Native", instructor:"Wasiur Rahman", price:40,img:'https://i.ibb.co/j83RmrG/f.jpg'},
    {key:"6", title:"JavaScript Guideline", instructor:"Zahidur Rahman", price:30,img:'https://i.ibb.co/PGtkMv6/g.jpg'},
    {key:"7", title:"Web  Bootcamp", instructor:"Mushfiqur Rahman", price:25,img:'https://i.ibb.co/Sfcxczg/h.jpg'},
    {key:"8", title:"Android Development", instructor:"Shahnewaz Saad", price:20,img:'https://i.ibb.co/P5bSxvR/i.jpg'},
    {key:"9", title:"Java Development", instructor:"Rafid Rezwan", price:40,img:'https://i.ibb.co/CzXfkX0/j.jpg'},
    {key:"10", title:"Bootstrap Guide", instructor:"Ishrak Hossain", price:60,img:'https://i.ibb.co/qgFHZwZ/k.jpg'},
    {key:"11", title:"Vue Js Development", instructor:"Ahmed Neehal", price:30,img:'https://i.ibb.co/fvQwjqD/l.jpg'},
    {key:"12", title:"JavaScript-Projects", instructor:"Touhidul Utsho", price:50,img:'https://i.ibb.co/3kvsGpB/m.jpg'},
    {key:"13", title:"Front-end Guideline", instructor:"Nafis Shahriar", price:30,img:'https://i.ibb.co/WcNxyKg/n.jpg'},
    {key:"14", title:"Laravel Backend", instructor:"Farshid Ahsan", price:50,img:'https://i.ibb.co/M5dj90D/o.jpg'},
    {key:"15", title:"English Literature", instructor:"Sakib Mahmud", price:20,img:'https://i.ibb.co/M5dj90D/o.jpg'},
    {key:"15", title:"PHP development", instructor:"Hamza Momoa", price:20,img:'https://i.ibb.co/M5dj90D/o.jpg'}
    ];
    
export default courses;















